module.exports = __webpack_public_path__ + "img/header-logo.64e8180d.png";